import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { API_VERSION } from '@app/core/api.version';
import { Event, EventFilter, PaginatedResponse } from '@app/entity';

@Injectable()
export class EventsService {
  private url = `/${API_VERSION}/events/`;

  constructor(private http: HttpClient) { }

  list(pageUrl?: string, filters?: EventFilter): Observable<PaginatedResponse<Event>> {
    let params = new HttpParams();
    if (filters && filters.exclude) params = params.set('exclude', filters.exclude + '');
    if (filters && filters.page_size) params = params.set('page_size', filters.page_size + '');
    if (filters && filters.city) params = params.set('city', filters.city + '');
    if (filters && filters.date_0) params = params.set('date_0', filters.date_0);
    if (filters && filters.date_1) params = params.set('date_1', filters.date_1);
    return this.http.get<PaginatedResponse<Event>>(pageUrl || this.url, { params });
  }

  get(slug?: string): Observable<Event> {
    if (!slug) return Observable.of(null);
    return this.http.get<Event>(this.url + `${slug}/`);
  }

  calendar(filters?: EventFilter): Observable<Object> {
    let params = new HttpParams();
    if (filters && filters.city) params = params.set('city', filters.city + '');
    if (filters && filters.date_0) params = params.set('date_0', filters.date_0);
    if (filters && filters.date_1) params = params.set('date_1', filters.date_1);
    return this.http.get<Object>(this.url + 'calendar/', { params });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/events.service.ts